import { IVideoData } from "../hooks/useVideoData"

export function getVideoStatus(video: IVideoData) {
  if (video.extractionStatus === "pending") {
    return "Pending" as const
  } else if (video.extractionStatus === "error") {
    return "Error" as const
  } else if (video.extractionStatus === "processing") {
    return "Processing" as const
  } else {
    if (video.videoFiles.every(videoFile => videoFile.processingStatus === "done")) {
      return "Done" as const
    }
    const hasAnyAudio = video.videoFiles.some(videoFile => videoFile.type === "audio")
    const hasOneAudio = video.videoFiles.some(
      videoFile => videoFile.processingStatus === "done" && videoFile.type === "audio",
    )
    const hasOneVideo = video.videoFiles.some(
      videoFile => videoFile.processingStatus === "done" && videoFile.type === "video",
    )

    const allAudioErrored = video.videoFiles.some(
      videoFile => videoFile.processingStatus === "error" && videoFile.type === "audio",
    )
    const allVideoErrored = video.videoFiles.some(
      videoFile => videoFile.processingStatus === "error" && videoFile.type === "video",
    )

    if ((hasOneAudio && hasOneVideo) || (!hasAnyAudio && hasOneVideo)) {
      return "Playable" as const
    } else if (allAudioErrored || allVideoErrored) {
      return "Error" as const
    } else {
      return "Processing" as const
    }
  }
}
